import ApiCore from './api-core'
import { DRIVER } from '@/constants/api-types'

export default class Contract extends ApiCore {
  constructor(store) {
    const path = `${DRIVER}/user/contract`
    super(store, path)
  }

  list(showProgress) {
    return this.request({
      action: 'list',
      method: 'GET',
      showProgress
    })
  }
}
